import React, { useRef, useState } from "react";
import { Box, Button, Divider, Modal, Typography } from "@mui/material";
import _ from "lodash";
import { useEffect } from "react";
import AgentService from "../../Services/AgentService";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate, useParams } from "react-router-dom";
import TopBar from "../Common/TopBar";
import MiscUtils from "../../Utils/MiscUtils";
import FieldAgentReturnOrderStatusCard from "./FieldAgentReturnOrderStatusCard";
import ProductCardWithQuantityFullWidth from "../Common/ProductCardWithQuantityFullWidth";
import AmountUtils from "../../Utils/AmountUtils";
import { makeStyles } from "@mui/styles";
import BlockUi from "react-block-ui";
import ActionConfirmationDrawer from "../Common/ActionConfirmationDrawer";
import FARejectOrderReasonsDrawer from "./FARejectOrderReasonsDrawer";
import { FilePond, registerPlugin } from "react-filepond";
import CommonConstantValues from "../../Services/CommonConstantValues";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import Toast from "../Common/Toast";
import DocumentService from "../../Services/DocumentService";
import "./style.css";
import FileUploadDrawer from "./FileUploadDrawer";
import StringUtils from "../../Utils/StringUtils";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddCommentDrawer from "./AddCommentDrawer";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";
import CommentCard from "./CommentCard";

const useStyles = makeStyles({
  returnInfoContainer: {
    background: "white",
    borderRadius: "10px",
    padding: "10px",
    margin: "10px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  retrunIdContainer: {
    display: "flex",
    flexDirection: "column",
  },
  returnIdText: {
    fontSize: "12px",
    fontWeight: "500px",
  },
  createdOnDateText: {
    fontSize: "12px",
    color: "#4F4F4F",
  },
  titleText: {
    fontWeight: "600",
    fontSize: "14px",
    margin: "10px",
  },
  shopInfoContainer: {
    margin: "10px",
    padding: "10px",
    borderRadius: "10px",
    background: "white",
  },
  shopAddressText: {
    display: "flex",
    alignItems: "flex-start",
    marginTop: "6px",
    fontSize: "12px",
  },
  accordian: {
    border: "none",
    width: "100%",
    padding: 0,
    marginBottom: "10px",
    "&.MuiAccordion-root:before": {
      display: "none",
    },
  },
  statsContainer: {
    display: "flex",
    flexDirection: "row",
  },
  statsItemContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "4px",
  },
  statsNumber: {
    fontSize: "14px",
    fontWeight: "600",
  },
  statsTitle: {
    fontSize: "12px",
    textAlign: "center",
  },
  totalAmountContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    padding: "10px",
    borderRadius: "4px",
    margin: "10px 0",
  },
  totalAmountTitle: {
    fontWeight: "600",
    fontSize: "14px",
  },
  totalAmount: {
    color: "#00733E",
    fontWeight: "600",
    fontSize: "14px",
  },
  commentActionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 10px",
  },
  addAttachmentContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#9D2123",
    fontWeight: "600",
  },
  addCommentButton: {
    fontWeight: "700",
    borderRadius: "16px",
    background: "#FFFFFF",
    textTransform: "capitalize",
    fontSize: "14px",
  },
  ctaContainer: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "50px",
    maxWidth: "600px",
  },
  rejectButton: {
    border: "1px solid #9D2123",
    color: "#9D2123",
    borderRadius: 0,
    background: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  approveButton: {
    backgroundColor: "#00733E",
    color: "white",
    borderRadius: 0,
    "&:hover": {
      backgroundColor: "#00733E",
    },
  },
  addBiltyButton: {
    background: "#9D2123",
    color: "white",
    borderRadius: 0,
    "&:hover": {
      backgroundColor: "#9D2123",
    },
  },
  commentCardContainer: {
    background: "white",
    margin: "0 10px 14px 10px",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    borderRadius: "10px",
  },
  comment: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  addComment: {
    margin: "10px",
    background: "white",
    borderRadius: "10px",
    ".MuiOutlinedInput-root": {
      borderRadius: "10px",
    },
  },
  modalBox: {
    position: "absolute",
    zIndex: "1000",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background: "#00000090",
  },
  errorDialogContainer: {
    display: "flex",
    flexDirection: "column",
    background: "white",
    padding: "20px",
    borderRadius: "4px",
    width: "70%",
  },
  errorDialogMessage: {
    marginBottom: "12px",
    color: "black",
    textAlign: "center",
  },
  errorDialogButtonContainer: {
    display: "flex",
    justifyContent: "space-around",
  },
});

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);
export default function FieldAgentReturnOrderDetail() {
  const styleClass = useStyles();
  const query = new URLSearchParams(window.location.search);
  const returnOrderId = query.get("returnOrderId");
  const navigate = useNavigate();

  const [returnDetail, setReturnDetail] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState("");
  const [showApproveConfirmation, setShowApproveConfirmation] = useState(false);
  const [showRejectReasons, setShowRejectReasons] = useState(false);
  const [selectedRejectReason, setSelectedRejectReason] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const rejectReasons = [
    "Partner Agreed To Liquidate",
    "No Return As Per Prior Commitment",
    "Change Return Quantity",
    "Return Window Closed",
    "Others",
  ];

  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showAddComment, setShowAddComment] = useState(false);
  const [showErrorDialog, shouldShowErrorDialog] = useState(false);
  useEffect(() => {
    const returnOrderDetailCB = getReturnOrderDetail();
    return returnOrderDetailCB;
  }, [returnOrderId]);

  const getReturnOrderDetail = () => {
    setLoading("started");
    const { axiosRequest, abortController } = AgentService.getReturnOrderDetail(
      returnOrderId,
      ""
    );
    axiosRequest
      .then((response) => {
        if (response?.data?.responseData) {
          const orderDetail = response?.data?.responseData;
          setReturnDetail(orderDetail);
          getComments(response?.data?.responseData?.ticketUUID);
          shouldShowErrorDialog(false);
        }
      })
      .catch((error) => {
        if (error?.message !== "canceled") {
          console.log(error);
          setLoading("done");
          shouldShowErrorDialog(true);
        }
      });
    return () => abortController.abort();
  };

  const getComments = (ticketId) => {
    const { axiosRequest } = AgentService.getCommentsOfOrder(ticketId);
    axiosRequest
      .then((response) => {
        setLoading("done");
        setComments(response?.data?.responseData?.comments);
        setTimeout(() => {
          addingCustomClickToDownloadImageInImgAndAnchorTag();
        }, 0);
      })
      .catch((error) => {
        console.log(error);
        setLoading("done");
      });
  };

  const addComments = (addedComment, files) => {
    setLoading("started");
    if (files.length > 0) {
      uploadAttachments("comment", files, addedComment);
    } else {
      const commentRequestData = {
        comment: addedComment,
        ticketUUID: returnDetail.ticketUUID,
      };
      addCommentForThisOrder(commentRequestData, false);
    }
  };

  const uploadBilty = (biltyFiles) => {
    setShowFileUpload(false);
    setLoading("started");
    console.log(biltyFiles);
    uploadAttachments("uploadBilty", biltyFiles);
  };

  const uploadAttachments = (
    attachmentFor,
    filesToBeUploaded,
    addedComment
  ) => {
    let s3UploadedObjectUrls = [];
    _.map(filesToBeUploaded, (file, index) => {
      const fileExtension = file?.fileExtension;
      const fileName = file?.file?.name ? `${file.file.name}` : `${file.id}`;
      const { axiosRequest } = DocumentService.getAttachmentS3Url(
        fileExtension,
        fileName,
        returnDetail?.farmerId
      );
      axiosRequest
        .then((response) => {
          const s3UrlResponse = response?.data?.responseData;
          console.log(s3UrlResponse);
          if (s3UrlResponse) {
            const { axiosRequest } = DocumentService.uploadDocumentToS3(
              s3UrlResponse.presignedUrl,
              file?.file,
              file?.fileType
            );
            axiosRequest
              .then((response) => {
                s3UploadedObjectUrls.push(s3UrlResponse.objectUrl);
                console.log(s3UrlResponse.objectUrl);
                if (s3UploadedObjectUrls.length === filesToBeUploaded.length) {
                  if (attachmentFor === "comment") {
                    const commentRequestData = {
                      comment: addedComment,
                      ticketUUID: returnDetail.ticketUUID,
                      s3urls: s3UploadedObjectUrls,
                    };
                    addCommentForThisOrder(commentRequestData, false);
                  } else {
                    addBiltyForThisOrder(s3UploadedObjectUrls);
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                setLoading("done");
                setShowToast(true);
                setToastMessage("Something went wrong");
              });
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading("done");
          setShowToast(true);
          setToastMessage("Something went wrong");
        });
    });
  };

  const addCommentForThisOrder = (
    commentRequestData,
    shouldFetchReturnOrderDetailAgain
  ) => {
    console.log(commentRequestData);
    const { axiosRequest } =
      AgentService.addCommentsForTheOrder(commentRequestData);
    axiosRequest
      .then((response) => {
        if (response?.data?.message === "OK") {
          setShowToast(true);
          setToastMessage("Comment Added Successfully");
          setLoading("done");
          if (shouldFetchReturnOrderDetailAgain) {
            getReturnOrderDetail();
          } else {
            getComments(returnDetail.ticketUUID);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setShowToast(true);
        setToastMessage("Something went wrong");
        setLoading("done");
      });
  };

  const markOrderAsRejected = () => {
    console.log(selectedRejectReason);
    setLoading("started");
    const commentRequestData = {
      comment: selectedRejectReason,
      ticketUUID: returnDetail.ticketUUID,
      ticketStatus: "Return Request Reject",
    };
    setShowRejectReasons(false);
    addCommentForThisOrder(commentRequestData, true);
  };

  const approveThisOrder = () => {
    const approveRequestData = {
      farmerId: returnDetail.farmerId,
      isReturnOrder: true,
      orderId: returnOrderId,
      type: "approve",
    };
    setLoading("started");
    const { axiosRequest } =
      AgentService.approveReturnOrders(approveRequestData);
    axiosRequest
      .then((response) => {
        setShowToast(true);
        setToastMessage("Order Approved Successfully");
        setLoading("done");
        getReturnOrderDetail();
      })
      .catch((error) => {
        console.log(error);
        setShowToast(true);
        setToastMessage("Something went wrong");
        setLoading("done");
      });
  };

  const getAddressAsAString = () => {
    if (returnDetail?.returnedBy?.address) {
      const address = returnDetail.returnedBy.address;
      return `${address.village}, ${address.postOffice}, ${address.taluka}, ${address.landMark}, ${address.district}, ${address.state}, ${address.country} - ${address.pincode}`;
    }
    return "";
  };

  const handleApprove = () => {
    setShowApproveConfirmation(true);
    const approveEventData = {
      page: "Field Agent Return Order Details",
      type: "Approve Button",
    };
    AnalyticsService.pushEvent("Button Clicked", approveEventData);
  };

  const markOrderAsApproved = () => {
    setShowApproveConfirmation(false);
    approveThisOrder();
  };

  const handleRejectClicked = () => {
    const rejectEventData = {
      page: "Field Agent Return Order Details",
      type: "Reject Button",
    };
    AnalyticsService.pushEvent("Button Clicked", rejectEventData);
    setShowRejectReasons(true);
  };

  const onUploadBiltyClicked = () => {
    const uploadBiltyEventData = {
      page: "Field Agent Return Order Details",
      type: "Add Bilty",
    };
    AnalyticsService.pushEvent("Button Clicked", uploadBiltyEventData);
    setShowFileUpload(true);
  };

  const addBiltyForThisOrder = (s3UploadedObjectUrls) => {
    console.log(s3UploadedObjectUrls);
    const commentRequestData = {
      comment: "Bilty Uploaded",
      ticketUUID: returnDetail.ticketUUID,
      s3urls: s3UploadedObjectUrls,
      documentType: "BILTY",
      orderId: parseInt(returnOrderId),
    };
    const { axiosRequest } =
      AgentService.addCommentsForTheOrder(commentRequestData);
    axiosRequest
      .then((response) => {
        if (response?.data?.message === "OK") {
          setShowToast(true);
          setToastMessage("Bilty Added Successfully");
          setLoading("done");
          getReturnOrderDetail();
        }
      })
      .catch((error) => {
        console.log(error);
        setShowToast(true);
        setToastMessage("Something went wrong");
        setLoading("done");
      });
  };

  const handleAddCommentClicked = () => {
    const addCommentAnalyticsData = {
      page: "Field Agent Return Order Details",
      pageId: returnOrderId,
      type: "Add Comment",
    };
    AnalyticsService.pushEvent("Button Clicked", addCommentAnalyticsData);
    setShowAddComment(true);
  };

  const addingCustomClickToDownloadImageInImgAndAnchorTag = () => {
    document
      .querySelector("#comments-list")
      ?.querySelectorAll("a, img")
      ?.forEach((child) => {
        const downloadableLink =
          child.tagName === "A"
            ? child.getAttribute("href")
            : child.getAttribute("src");

        if (downloadableLink) {
          child.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              handleAndroidDownload(downloadableLink);
            },
            false
          );
        }
      });
  };

  const handleAndroidDownload = (imageUrl) => {
    if (AndroidService.checkIfAndroid()) {
      const fileName = MiscUtils.getFileName(imageUrl);
      const eventProperties = {
        page: "Field Agent Return Order Details",
        pageId: { returnOrderId },
        imageUrl: imageUrl,
      };
      const { appVersionCode } = AndroidService.getAndroidVersion();
      if (appVersionCode >= 11) {
        AnalyticsService.pushEvent(`Attachment Clicked`, eventProperties);
        AndroidService.downloadImage(fileName, imageUrl);
      }
    }
  };

  const handleBackClicked = () => {
    if (window.history.visitedLength > 1) {
      window.history.go(-1);
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <BlockUi
      tag="div"
      blocking={loading === "started"}
      message={`Loading...`}
      style={{ minHeight: "85vh" }}
      keepInView
    >
      <Box sx={{ paddingBottom: "50px", minHeight: "20vh" }}>
        <TopBar title="Return Order Details" backNavigation={true} />
        <Box className={styleClass.returnInfoContainer}>
          <Box className={styleClass.retrunIdContainer}>
            <Typography className={styleClass.returnIdText}>
              Return ID : {returnOrderId}
            </Typography>
            <Typography className={styleClass.createdOnDateText}>
              Date :{" "}
              {MiscUtils.getDateInFormat(
                returnDetail?.orderCreatedOn,
                "D MMM YYYY"
              )}
            </Typography>
          </Box>
          <FieldAgentReturnOrderStatusCard status={returnDetail?.status} />
        </Box>
        {returnDetail?.returnedBy && (
          <>
            <Typography className={styleClass.titleText}>Return By</Typography>
            <Box className={styleClass.shopInfoContainer}>
              <Typography sx={{ fontWeight: "600", fontSize: "12px" }}>
                {returnDetail?.returnedBy?.name}
              </Typography>
              <Typography
                component="span"
                className={styleClass.shopAddressText}
              >
                <LocationOnIcon
                  sx={{ color: "#666666", height: "18px", width: "18px" }}
                />{" "}
                {StringUtils.convertToTitleCase(getAddressAsAString())}
              </Typography>
            </Box>
          </>
        )}
        <Typography className={styleClass.titleText}>
          Items in this Order
        </Typography>
        {_.map(returnDetail?.orderItems, (orderItem, index) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                background: "white",
                marginBottom: "10px",
              }}
              key={index}
            >
              <ProductCardWithQuantityFullWidth
                data={orderItem}
                amount={orderItem.returnableAmount}
              />
              <Divider />
              <Box className={styleClass.statsContainer}>
                <Box className={styleClass.statsItemContainer}>
                  <Typography className={styleClass.statsNumber}>
                    {orderItem.skuOrderStats?.totalSaleQuantity}
                  </Typography>
                  <Typography className={styleClass.statsTitle}>
                    Purchased QTY in last 12 months
                  </Typography>
                </Box>
                <Box className={styleClass.statsItemContainer}>
                  <Typography className={styleClass.statsNumber}>
                    {orderItem.skuOrderStats?.totalReturnQuantity}
                  </Typography>
                  <Typography className={styleClass.statsTitle}>
                    Returned QTY in last 12 months
                  </Typography>
                </Box>
                <Box className={styleClass.statsItemContainer}>
                  <Typography
                    className={styleClass.statsNumber}
                    sx={{
                      color: "#9D2123",
                    }}
                  >
                    {Math.round(
                      orderItem.skuOrderStats?.returnPercentage?.toFixed(1)
                    )}
                    {""}%
                  </Typography>
                  <Typography className={styleClass.statsTitle}>
                    Returned percentage in last 12 months
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
        <Box className={styleClass.totalAmountContainer}>
          <Typography className={styleClass.totalAmountTitle}>
            Total Amount
          </Typography>
          <Typography className={styleClass.totalAmount}>
            {AmountUtils.formatCurrency(returnDetail?.totalReturnableAmount)}
          </Typography>
        </Box>

        <Typography className={styleClass.titleText}>Comments</Typography>
        <Typography
          sx={{
            background: "white",
            border: "1px solid #9D2123",
            borderRadius: "12px",
            padding: "8px",
            margin: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#9D2123",
            fontWeight: "600",
            fontSize: "14px",
          }}
          onClick={() => {
            handleAddCommentClicked();
          }}
        >
          Add a new comment
          <ArrowForwardIosIcon sx={{ fontSize: "14px" }} />
        </Typography>
        {comments && (
          <Box
            id={"comments-list"}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {_.map(comments, (comment, index) => {
              return <CommentCard comment={comment} key={index} />;
            })}
          </Box>
        )}
      </Box>
      <Box className={styleClass.ctaContainer}>
        {returnDetail?.canReject && (
          <Button
            fullWidth
            className={styleClass.rejectButton}
            onClick={() => handleRejectClicked()}
          >
            Reject
          </Button>
        )}
        {returnDetail?.canApprove && (
          <Button
            fullWidth
            className={styleClass.approveButton}
            onClick={() => handleApprove()}
          >
            Approve
          </Button>
        )}
        {returnDetail?.canUploadBilty && (
          <Button
            fullWidth
            className={styleClass.addBiltyButton}
            onClick={() => {
              onUploadBiltyClicked();
            }}
          >
            Add Bilty
          </Button>
        )}
      </Box>
      <ActionConfirmationDrawer
        showConfirmation={showApproveConfirmation}
        setShowConfirmation={setShowApproveConfirmation}
        svg={"/icons/confirmationQuestionMark.svg"}
        confirmationMessage={"Are you sure you want to approve?"}
        actionText={"Approve"}
        handleAction={markOrderAsApproved}
      />
      <FARejectOrderReasonsDrawer
        setSelectedRejectReason={setSelectedRejectReason}
        selectedRejectReason={selectedRejectReason}
        showRejectReasons={showRejectReasons}
        setShowRejectReasons={setShowRejectReasons}
        reasons={rejectReasons}
        handleRejectionCallback={markOrderAsRejected}
        actionText={"Reject"}
      />
      <Toast show={showToast} setShow={setShowToast} alertText={toastMessage} />
      <FileUploadDrawer
        showFileUpload={showFileUpload}
        setShowFileUpload={setShowFileUpload}
        uploadBilty={uploadBilty}
        page={`Field Agent Return Order Detail`}
      />
      <AddCommentDrawer
        setShowAddComment={setShowAddComment}
        showAddComment={showAddComment}
        addCommentCallback={addComments}
      />
      <Modal className={styleClass.modalBox} open={showErrorDialog}>
        <Box className={styleClass.errorDialogContainer}>
          <Typography
            variant="subtitle1"
            className={styleClass.errorDialogMessage}
          >
            Sorry, something went wrong. Please try again in sometime.
          </Typography>
          <Box className={styleClass.errorDialogButtonContainer}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                shouldShowErrorDialog(false);
                handleBackClicked();
              }}
            >
              Okay
            </Button>
          </Box>
        </Box>
      </Modal>
    </BlockUi>
  );
}
